// extracted by mini-css-extract-plugin
export var divider = "_ms-0";
export var systemMessage = "_ms-1";
export var systemMessageWrapper = "_ms-2";